module.exports = __webpack_public_path__ + "img/working.28be6a2b.svg";